// FieldTextarea Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import WysiwygEditor from '../../../common/form/wysiwyg_editor/wysiwyg_editor.jsx'
import IconButton from '../../common/icon_button/icon_button.jsx'

class FieldTextArea extends Component {
  constructor (props) {
    super(props)

    this.state = {
      bEdit: false,
      isFocus: false
    }

    this._references = {
      field: React.createRef()
    }
  }

  static get propTypes () {
    return {
      showEdit: PropTypes.bool,
      readOnly: PropTypes.bool,
      value: PropTypes.string,
      className: PropTypes.string,
      onSave: PropTypes.func,
      onFocus: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      showEdit: true,
      readOnly: false,
      value: '',
      className: '',
      onSave: null,
      onFocus: null
    }
  }

  componentDidUpdate (prevProps, prevState) {
    if (
      this.props.showEdit &&
      this.state.bEdit &&
      this.state.bEdit !== prevState.bEdit
    ) {
      if (this._references.field.current) {
        this._references.field.current.focus()
      }
    }
  }

  render () {
    const {
      showEdit,
      onSave,
      readOnly,
      value,
      className,
      ...others
    } = this.props
    const { bEdit, isFocus } = this.state

    const _className = classNames(className, {
      hasfocus: isFocus
    })

    return (
      <div
        className={`field field-textarea${
          showEdit && !bEdit ? ' disableedit' : ''
        }${readOnly ? ' viewtextarea' : ''}`}
      >
        <div className='fieldcontent'>
          {readOnly ? (
            <div className='wysiwyg-editor'>
              <div className='typo typo_alt ctextarea'>
                <div
                  className='fr-element'
                  dangerouslySetInnerHTML={{ __html: value }}
                />
              </div>
            </div>
          ) : (
            <WysiwygEditor
              ref={this._references.field}
              className={_className}
              value={value}
              {...others}
              onBlur={this._onBlur.bind(this)}
              onFocus={this._onFocus} // eslint-disable-line react/jsx-handler-names
            />
          )}
        </div>
        {showEdit &&
          (bEdit ? (
            <IconButton
              className='fieldaction'
              icon='done'
              type='primary'
              onClick={this._onSave.bind(this)}
            />
          ) : (
            <IconButton
              className='fieldaction'
              icon='edit'
              type='secondary'
              canHover
              onClick={this._onEnabledEdit.bind(this)}
            />
          ))}
      </div>
    )
  }

  /* Event Handlers */
  _onEnabledEdit () {
    this.setState({ bEdit: true })
  }

  _onSave (ev) {
    this.setState({ bEdit: false })

    if (this.props.onSave) {
      this.props.onSave(ev)
    }
  }

  _onBlur (ev) {
    this.setState({ isFocus: false })
    this._onSave(ev)
  }

  _onFocus = ev => {
    this.setState({ isFocus: true })

    const { onFocus } = this.props
    if (onFocus) {
      onFocus(ev)
    }
  }
}

export default FieldTextArea
